import React from 'react';
import { CerebroBreadcrumb, CerebroPageContainer, CerebroSecondaryButton } from '../../shared/components';
import { EmptyGuid } from '../../shared/constants';
import { useDataRoomCallQuery } from '../../shared/hooks';
import { CurrentUser, DataRoomCall } from '../../shared/models';
import { CallForm } from './CallForm';
import { CallsDisplay } from './CallsDisplay';
import { ConfirmCallDialog } from './ConfirmCallDialog';
import { ResetCallDialog } from './ResetCallDialog';

interface CallsPageProps {
	dataRoomGuid: string | undefined;
	currentUser: CurrentUser;
}

export const CallsPage: React.FC<CallsPageProps> = ({ dataRoomGuid, currentUser }) => {
	const callsQuery = useDataRoomCallQuery(dataRoomGuid);

	const [scheduleCall, setScheduleCall] = React.useState<DataRoomCall | null>(null);
	const [markCallComplete, setMarkCallComplete] = React.useState<DataRoomCall | null>(null);
	const [resetCall, setResetCall] = React.useState<DataRoomCall | null>(null);

	const onAddScheduleCall = () => {
		setScheduleCall({
			id: 0,
			guid: EmptyGuid,
		} as DataRoomCall);
	};

	const closeDrawersAndDialogs = () => {
		setScheduleCall(null);
		setMarkCallComplete(null);
		setResetCall(null);
	};

	return (
		<CerebroPageContainer maxWidth="100%">
			<CerebroBreadcrumb>Call Scheduling</CerebroBreadcrumb>

			{callsQuery.isSuccess && (
				<CerebroSecondaryButton onClick={() => onAddScheduleCall()} sx={{ marginBottom: 2 }}>
					Schedule Call
				</CerebroSecondaryButton>
			)}

			<CallsDisplay
				dataRoomGuid={dataRoomGuid}
				isLoading={callsQuery.isLoading}
				calls={callsQuery.data}
				onEdit={setScheduleCall}
				onConfirm={setMarkCallComplete}
				onReset={setResetCall}
			/>

			<ConfirmCallDialog call={markCallComplete} dataRoomGuid={dataRoomGuid} close={closeDrawersAndDialogs} />
			<ResetCallDialog call={resetCall} dataRoomGuid={dataRoomGuid} close={closeDrawersAndDialogs}/>
			<CallForm dataRoomGuid={dataRoomGuid} call={scheduleCall} close={closeDrawersAndDialogs} />
		</CerebroPageContainer>
	);
};
